export enum ActionType {
  ADD_IMAGE,
  CUSTOM_SIZE,
  REMOVE_BG,
  REMOVE_OBJ,
  ADD_TEMPLATE,
  QUICK_TUTORIAL,
  MAGIC_BACKGROUND,
  ENHANCE,
  TUTORIAL_AIEDIT,
  AI_STYLE,
  AIEDIT,
  AI_IMAGE,
  AI_FASHION_MODEL,
  PHOTOSHOOT_PRELOAD,
}
